import React from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";

const NotFound = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    }}
  >
    <h1 style={{ fontSize: "15em", marginBottom: 0 }}>404</h1>
    <h3 style={{ fontSize: "3em", marginTop: 0 }}>Page Not Found</h3>
    <br /> <br />
    <Button
      size="huge"
      color="teal"
      basic
      as={Link}
      to="/"
      content="Home Page"
    />
  </div>
);

export default NotFound;
